<template>
  <el-container>
    <div class='navbar'>
      <hamburger id='hamburger-container' :is-active='sidebar.opened' class='hamburger-container'
                 @toggleClick='toggleSideBar' />
      <breadcrumb id='breadcrumb-container' class='breadcrumb-container' />
      <div class='right-menu'>
        <el-dropdown class='right-menu-item' @command='handleCommand'>
          <div style='font-size: 16px;' align='center'>
            <img src='../../assets/404_images/user.png' style='height: 30px;float: left;margin-top: 10px;' />
            <div style='float: right;padding-left: 10px;'>{{ name }}</div>
          </div>
          <el-dropdown-menu slot='dropdown'>
            <el-dropdown-item command='pw'><i class='el-icon-key'></i>修改密码</el-dropdown-item>
            <el-dropdown-item command='setting'><i class='el-icon-edit'></i>修改信息</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <!--        <div class="right-menu-item" style="margin-right: 0.20rem;font-size: 15px;" @click="screenClick">-->
        <!--          <el-tooltip class="item" effect="dark" content="(1)-点击跳转到大屏  (2)-按电脑键盘F11全屏  (3)-按电脑键盘F5刷新数据  (4)-如果页面错位请调整电脑分辨率 " placement="bottom-end">-->
        <!--            <el-button type="text" plain>大屏</el-button>-->
        <!--          </el-tooltip>-->
        <!--        </div>-->
        <div class='right-menu-item' style='margin-right: 1rem;font-size: 15px;' @click='logout'>
          <i class='el-icon-switch-button' />
          退出
        </div>
      </div>
    </div>
    <el-dialog title='修改密码' :visible.sync='dialogPasswordVisible' width='25%' append-to-body>
      <el-form :label-position='labelPosition' label-width='60px' :model='passwordData'>
        <el-form-item label='新密码'>
          <el-input t v-model='passwordData.password' placeholder='请输入新密码'></el-input>
        </el-form-item>
      </el-form>
      <div slot='footer' class='dialog-footer'>
        <el-button icon='el-icon-circle-close' @click='dialogPasswordVisible = false'>取 消</el-button>
        <el-button type='primary' icon='el-icon-circle-plus-outline' @click='handlePasswordClick'>确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title='修改信息' :visible.sync='dialogUserVisible' width='25%' append-to-body>
      <el-form :label-position='labelPosition' label-width='60px' :model='userdData'>
        <el-form-item label='姓名'>
          <el-input v-model='userdData.name' placeholder='请输入用户姓名'></el-input>
        </el-form-item>
        <el-form-item label='电话'>
          <el-input t v-model='userdData.phone' placeholder='请输入电话号码'></el-input>
        </el-form-item>
      </el-form>
      <div slot='footer' class='dialog-footer'>
        <el-button icon='el-icon-circle-close' @click='dialogUserVisible = false'>取 消</el-button>
        <el-button type='primary' icon='el-icon-circle-plus-outline' @click='handleUserClick'>确 定</el-button>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import { setCookie, getCookie, getToken } from '@/utils/auth'
import ElContainer from '../../../node_modules/element-ui/packages/container/src/main.vue'
import { gateway } from '@/api/admin.js'

export default {
  components: {
    ElContainer,
    Breadcrumb,
    Hamburger
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar',
      'device'
    ]),
    name() {
      return getCookie('login_name')
    }
  },
  data() {
    return {
      labelPosition: 'center',
      dialogPasswordVisible: false,
      dialogUserVisible: false,
      loading: false,
      passwordData: {
        password: ''
      },
      userdData: {
        id:null,
        role_id: null,
        phone: '',
        name: ''
      }
    }
  },
  methods: {
    handleCommand: function(command) {

      if (command == 'pw') {
        this.passwordData = { old: '', new: '' }
        this.dialogPasswordVisible = true
      } else if (command == 'setting') {
        this.userdData = { phone: getCookie('phone'), name: getCookie('name') }
        this.dialogUserVisible = true
      }
    },
    handlePasswordClick: function() {
      console.log(this.passwordData.password)
      if (this.passwordData.password == '' || this.passwordData.password == undefined) {
        this.$message.warning('修改内容不能为空')
        return
      }
      gateway({
        func: 'set_agency_password_me',
        params: JSON.stringify(this.passwordData)
      }).then(res => {
        if (res.code === 0) {
          this.dialogPasswordVisible = false
          this.$message.success('修改密码成功')
        } else {
          this.$message.warning(res.msg)
        }
      })
    },


    handleUserClick: function() {
      if (this.userdData.name == '') {
        this.$message.warning('请输入用户姓名')
        return
      }
      this.userdData.role_id = parseInt(getCookie('role_id'))
      this.userdData.id= parseInt(getCookie('id'))
      gateway({
        func: 'set_agency_user_info',
        params: JSON.stringify(this.userdData)
      }).then(res => {
        if (res.code === 0) {
          this.dialogUserVisible = false
          this.$message.success('修改信息成功')
          setCookie('phone', this.userdData.phone)
          setCookie('name', this.userdData.name)
        } else {
          this.$message.warning(res.msg)
        }
      })
    },
    // 裁剪字符串
    sliceStr(str) {
      return str.length > 12 ? str.slice(0, 12) + '...' : str
    },
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },

    async screenClick() {
      var token = getToken()

      window.open('/dashboard?token=' + token)
    },

    async logout() {

      this.$confirm('是否退出登录？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store.dispatch('FedLogOut')
        this.$router.push(`/login`)
        // window.location.reload() // 退出到登录页
      }).catch(() => {

      })
    },
    ToggleTaskBar() {
      this.$store.dispatch('app/toggleTaskBar', true)
    }
  }
}
</script>

<style lang='scss' scoped>
.search-wrap {
  .search-tip {
    line-height: 50px;
    color: #ccc;
    text-align: center;
  }

  .search-item {
    list-style: none;
    padding: 0;

    li {
      padding: 0 6px;
      transition: .3s;
      cursor: pointer;
      line-height: 2.2rem;
      border-radius: 4px;

      &:hover {
        background: #f5f7fa;
      }
    }

    .item-right {
      float: right;
      color: rgb(132, 146, 166);
      font-size: 13px;
    }
  }
}

.navbar {
  width: 100%;
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, .08);

  .el-badge {
    line-height: normal;
  }

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background .3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, .025)
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 14px;
      color: #5a5e66;
      vertical-align: text-bottom;
      padding: 0 12px;
      transition: .3s;
      cursor: pointer;

      &:hover {
        background: rgba(0, 0, 0, .025)
      }
    }
  }
}
</style>
